module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/ant-portuguese.b547e529.jpg";